import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { AuthHeader } from 'components';
import Login from 'components/Auth/Login';
import { useGoogleLogin } from 'hooks/useGoogleLogin';
import { InviteService } from 'lib';
import Utils from 'lib/Utils';
import { routeConstants } from 'routes';
import { selectInvite, verifyInviteRequest } from 'store/Invites';
import AuthMFAVerification from './AuthMFAVerification';
import AuthTerms from './AuthTerms';

const AuthAcceptInviteLogin: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const invite = useSelector(selectInvite);
  const inviteToken = InviteService.getInviteToken();

  const { googleAuthInit, googleUnavailable } = useGoogleLogin({
    redirectUri: Utils.buildUrl(routeConstants.public.invites.invitesRedirectGoogle.login),
  });

  useEffect(() => {
    if (!invite && inviteToken) dispatch(verifyInviteRequest(inviteToken));
  }, [invite, inviteToken, dispatch]);

  return (
    <Login
      handleGoogleLogin={googleAuthInit}
      isGoogleUnavailable={googleUnavailable}
      authHeader={<AuthHeader data-cy="auth-header-login" title="Accept Invitation" subtitle="You’ve been invited to join your employer on Kickfin. Create an account or log in to accept the invitation." />}
      authTerms={<AuthTerms />}
      onForgotPasswordClick={() => history.push(routeConstants.public.invites.invitesResetPassword)}
      signupText="New to Kickfin? Your employer will send an invitation for you to create an account. Check your email or text messages and click on the URL when it arrives."
      renderMFAVerification={({ mfaRequired, onBack }) => <AuthMFAVerification mfaRequired={mfaRequired} onBack={onBack} />}
    />
  );
};

export default AuthAcceptInviteLogin;
